import { fixHangers } from '@/shared/lib/typography';
import { SURFACE } from '@/shared/lib/surface';
import styles from './ls-step-head.module.scss';

interface Props {
  /** «Шаг 1», «Шаг 3» — крупно, слева. */
  step: string;
  /** Что делают на этом шаге. */
  hint?: string;
  /**
   * Тот же шаг одним словом — для мини-приложения.
   *
   * Там шапка шага и есть заголовок экрана, а пояснение в три строки
   * заголовком быть не может: оно занимает четверть экрана телефона
   * и читается как текст, а не как название места. На сайте пояснение
   * стоит рядом с номером шага и места не отнимает, поэтому остаётся
   * полным.
   */
  short?: string;
  /** Цена сборки на сегодняшний момент. */
  priceLabel?: string;
  price?: string;
  logoUrl?: string;
}

/**
 * Шапка шага: номер, пояснение, цена и логотип заказчика.
 *
 * Цена стоит в шапке, а не у кнопки заказа, намеренно: она меняется по ходу
 * сборки, и человек должен видеть её всё время, а не встретить в конце.
 *
 * В мини-приложении шапка короче: только название шага. Номер шага там
 * рисует полоса внизу, знак заказчика стоит в шапке самого приложения,
 * а цена видна в составе заказа. Полная шапка давала на экране телефона
 * два одинаковых логотипа рядом и две записи об одном и том же шаге —
 * и всё это в верхней трети, где места меньше всего.
 */
export function LsStepHead({ step, hint, short, priceLabel, price, logoUrl }: Props) {
  const isMini = SURFACE === 'miniapp';

  if (isMini) {
    return (
      <header className={`${styles['ls-step-head']} ${styles['ls-step-head--is-bare']}`}>
        <p className={styles['ls-step-head__hint']}>{fixHangers(short ?? hint ?? '')}</p>
      </header>
    );
  }

  return (
    <header className={styles['ls-step-head']}>
      <p className={styles['ls-step-head__step']}>{step}</p>

      {hint && <p className={styles['ls-step-head__hint']}>{fixHangers(hint)}</p>}

      {price && (
        <p className={styles['ls-step-head__price']}>
          {priceLabel && <span className={styles['ls-step-head__price-label']}>{priceLabel}</span>}
          {price}
        </p>
      )}

      {logoUrl && (
        <img className={styles['ls-step-head__logo']} src={logoUrl} alt="" aria-hidden="true" />
      )}
    </header>
  );
}
